import { useCallback, useContext, useEffect, useState } from "react";

import { ProjectPermissionConstants } from "../../../../../../../constants";
import { ProjectDates, ProjectDatesSchema } from "../../../../../../../models";
import { getStandardSpecificSchemaDetails } from "../../../../../../../service/query";
import { Status } from "../../../../../../../service/Shared";
import { ProjectContext } from "../../../ProjectContext";

interface DatesSectionReturnData {
  dates?: ProjectDates;
  isReadOnly: boolean;
  dateSchema?: ProjectDatesSchema;
}
export const useDatesSection = (): DatesSectionReturnData => {
  const { projectDates, hasProjectPermission } = useContext(ProjectContext);

  const [dateSchema, setDateSchema] = useState<ProjectDatesSchema>();

  const getAndSetProjectDatesSchema = useCallback(
    async (uuid: string): Promise<void> => {
      const result = await getStandardSpecificSchemaDetails({ standardSpecificSchemaUuid: uuid });
      if (result.status === Status.Success && result.data) {
        setDateSchema(JSON.parse(result.data.dateSchema).properties as ProjectDatesSchema);
      }
    },
    [projectDates?.standardSpecificSchemaUuid]
  );

  useEffect(() => {
    if (projectDates?.standardSpecificSchemaUuid) getAndSetProjectDatesSchema(projectDates.standardSpecificSchemaUuid);
  }, [projectDates]);

  return {
    dates: projectDates?.dates,
    isReadOnly: !hasProjectPermission(ProjectPermissionConstants.WRITE_PROJECT_DATES),
    dateSchema,
  };
};
